const ENDPOINTS = {
  // Auth
  LOGIN: `/Auth/login`,
  LOGOUT: (id) => `/Auth/logoutid/${id}`,
  REFRESH: `/Auth/refresh`,
  CREATE_PASSWORD: "/Auth/createpassword",
  FORGOT_PASSWORD_SEND_OTP: "/Auth/Forgot-password-send-otp",
  FORGOT_PASSWORD_VERIFY_OTP: "/Auth/Forgot-password-verify-otp",
  RESET_PASSWORD: "/Auth/reset-password",
  OTP_GENERATE_PDF: "/Auth/otp-generate-for-pdfdocument",
  OTP_VERIFY_PDF: "/Auth/verify-otp-for-pdfdocument",

  // Company
  ROLE: `/CompanyDetails/security-groups-name`,
  DEPARTMENT: `/CompanyDetails/departments`,
  DESIGNATION: `/CompanyDetails/designation`,

  // Approval Flow
  BUSINESSUNIT: `/ApprovalFlow/business-units`,
  SINGLELEVELAPPROVALTYPE: `/ApprovalFlow/approval-types`,
  MULTILEVELAPPROVAL: `/ApprovalFlow/multilevel-approvals`,
  MULTILEVELAPPROVAL_BY_ID: (id) => `/ApprovalFlow/multilevel-approvals/${id}`,
  CUSTOMERSUBREGION: `/ApprovalFlow/customer-sub-region`,
  CUSTOMERSUBREGIONPOST: `/ApprovalFlow/add-customer-sub-region`,
  APPROVAL_FLOW_SUBMIT: "/ApprovalFlow",
  APPROVAL_STATUSES_BY_CUSTOMER: (customerId) => `/ApprovalFlow/approvalstatuses-by-customer-id/${customerId}`,
  ALL_APPROVAL_STATUSES_BY_CUSTOMER: (customerId) => `/ApprovalFlow/all-approvalstatuses-by-customer-id/${customerId}`,
  UPDATE_CUSTOMER_APPROVAL_HIERARCHY: `/ApprovalFlow/update-customer-approval-hierarchy`,
  UPDATE_CUSTOMER_SELLER: `/ApprovalFlow/update-customer-seller`,
  CUSTOMER_BUNITS_BY_CUSTOMER: (custId, regId) => `/ApprovalFlow/customer-bunits?custId=${custId}&regId=${regId}`,
  CUSTOMER_BUNITS: `/ApprovalFlow/customer-bunits`,
  CUSTOMER_BUNITS_BY_ID: (id) => `/ApprovalFlow/customer-bunits/${id}`,
  REGION_SUBREGION_MAPPING: `/ApprovalFlow/region-subregion-mapping`,
  CHECK_CUSTOMER_HIERARCHY: (bunit, sellerId, subRegionId) => `/ApprovalFlow/check-customer-hierarchy?bunit=${bunit}&sellerId=${sellerId}&subRegionId=${subRegionId}`,
  SEND_CUSTOMER_EMAIL: (customerId, accountNumber) => `/ApprovalFlow/send-customer-email/${customerId}/${accountNumber}`,
  DELETE_CUSTOMER_SUBREGION: (id) => `/ApprovalFlow/delete-cust-subregion/${id}`,
  UPDATE_CUSTOMER_SUBREGION: (id) => `/ApprovalFlow/update-cust-subregion/${id}`,

  // Customer
  CUSTOMERTYPE: `/Customer/customer-types`,
  CUSTOMERTYPE_BY_ID: (id) => `/Customer/customer-types/${id}`,
  CUSTOMERREGION: `/Customer/customer-region-all`,
  CUSTOMERREGIONPOST: `/Customer/customer-region`,
  CUSTOMERREGION_BY_ID: (id) => `/Customer/customer-region/${id}`,
  EXISTINGCUSTOMER: `/Customer/get-all-customers`,
  GET_ALL_CUSTOMERS: "/Customer/get-all-customer-for-admin",
  CUSTOMER_ADD: "/Customer/add",
  CUSTOMER_UPDATE: (id) => `/Customer/update/${id}`,
  CUSTOMER_BY_SELLER: (sellerId) => `/Customer/get-existing-customer-bysellerid/${sellerId}`,
  CUSTOMER_FOR_APPROVAL: (id) => `/Customer/get-for-approval-customer-bysellerid/${id}`,
  CUSTOMER_UPDATE_GUARANTEE: "/Customer/update-customer-type-of-guarantee",
  CUSTOMER_COUNT_DASHBOARD: "/Customer/GetCustomerCountDashboard",
  CUSTOMER_BULK_UPLOAD: "/Customer/bulk-upload-customer",
  CUSTOMER_FEEDBACK_SUBMIT: "/Customer/CustomerFeedback",
  CUSTOMER_FEEDBACK_ALL: "/Customer/all-customer-feedbacks",

  // User
  USERGETALL: `/User/get-all`,
  GET_ALL_USERS: "/User/get-all",
  USERPOST: `/User/add`,
  USERDELETE: `/User/delete`,
  USERUPDATE: `/User/update`,
  USER_GET_BY_ID: (id) => `/User/get/${id}`,
  JKCUTOMREGISTER: `/User/jk-customer-register/Add`,
  USER_SAVE_CUSTOMER_ACCESS: "/User/save-customer-access",
  USER_UPDATE_CUSTOMER_ACCESS: "/User/update-customer-access",
  USER_DELETE_CUSTOMER_ACCESS: (id) => `/User/delete-all-customer-access/${id}`,
  USER_GET_CUSTOMER_ACCESS: "/User/get-customer-access",
  USER_GEO_MAPPING: (userId) => `/User/get_user_geo_mapping_by_user_id/${userId}`,
  USER_DISPUTE_HIERARCHY_ALL: "/User/get-all-customer-dispute-hierarchy",
  USER_DISPUTE_HIERARCHY_CREATE: "/User/dispute-tat-hierarchy",
  USER_DISPUTE_HIERARCHY_UPDATE: "/User/update-dispute-tat-hierarchy",
  USER_DISPUTE_HIERARCHY_DELETE: (custId, catId) => `/User/delete-dispute-tat-hierarchy?customerId=${custId}&categoryId=${catId}`,
  USER_BULK_UPLOAD_DISPUTE: "/User/bulk-upload-dispute",
  USER_GUIDE: "/User-Guide",

  // Credit Line
  CREDITLINE: {
    GET_BY_CUSTOMER: (userId) => `/CreditLine/get-by-customer-id/${userId}`,
    GET_BY_ID: (creditLineId) => `/CreditLine/${creditLineId}`,
    CREATE: "/CreditLine/creditline/create-credit-line",
    UPDATE: (id) => `/CreditLine/update/${id}`,
    DELETE: (creditLineId) => `/CreditLine/delete/${creditLineId}`,
    FOR_APPROVAL: (id) => `/CreditLine/get-for-Creditline-approval-customer-bysellerid/${id}`,
    VALIDATE_HIERARCHY: (cid) => `/CreditLine/validate-creditline-hirarchy/${cid}`,
  },

  // SAP Proxy Endpoints
  SAP: {
    ACCOUNT_STATEMENT: (id) => id ? `/account-statement?accCustNo=000${id}` : `/account-statement`,
    CUSTOMER_INVOICE: (id) => id ? `/customer-invoice?customerNo=000${id}` : `/customer-invoice`,
    CREDIT_NOTE: (id) => id ? `/credit-note?customerNo=000${id}` : `/credit-note`,
    PAYMENT_DETAILS: (id) => id ? `/payment-details?custNo=000${id}` : `/payment-details`,
    LOGISTIC_DETAILS: (id) => id ? `/logistic-details?customerNo=000${id}` : `/logistic-details`,
    CUSTOMER_DASHBOARD: (id) => `/customer-dashboard?customerId=000${id}`,
    PAYMENT_POST: "/payment-post",
  },

  // Invoices & Payments
  INVOICES: `/InvoiceDetails/InvoiceDetails`,
  PAYMENTDETAILS: `/CustomerPayment`,
  PAYMENT_DRAFT: {
    SAVE: `/PaymentDraft/save`,
    GET_BY_USER: (userId) => `/PaymentDraft/user/${userId}`,
    DELETE: (id) => `/PaymentDraft/${id}`,
  },
  CUSTOMER_PAYMENT: {
    UPDATE_REFERENCE: "/CustomerPayment/update-reference-number",
    SUPERVISOR_HISTORY: "/CustomerPayment/supervisor/history",
    SUBMIT: "/CustomerPayment/submit-payment",
    HISTORY: (customerId) => `/CustomerPayment/history/${customerId}`,
  },

  // Dispute
  DISPUTE: {
    SUBMIT: "/Dispute/Dispute-Submit",
    GET_BY_CUSTOMER: (customerId) => `/Dispute/getdispute-bycustomerid/${customerId}`,
    GET_BY_ASSIGNED_USER: (teamId) => `/Dispute/Getdispute-byAssignedUserId/${teamId}`,
    UPDATE_RESOLUTION: "/Dispute/update-resolution",
    HAS_HIERARCHY: (custId, catId) => `/Dispute/HasDisputeHierarchy?custId=${custId}&catId=${catId}`,
  },

  // Comment Log
  COMMENT_LOG: {
    GET_BY_DISPUTE: (disputeId) => `/CommentLog/dispute-comments/${disputeId}`,
    POST: "/CommentLog",
  },

  // Notifications
  NOTIFICATIONS_BY_USER: "/Notifications/by-user",
  NOTIFICATIONS: "/Notifications",

  // Logistics
  LOGISTIC_INSERT_POD_DATE: "/LogisticDetails/insert-pod-date-logistic",

  // Bulk Upload Logs
  LOGS: {
    FILES: "/Logs",
    DOWNLOAD_FILE: (id) => `/Logs/download/${id}`,
    DOWNLOAD_UPLOADED_FILE: (id) => `/Logs/download-excel/${id}`,
  },
  DISPUTE_LOGS: {
    FILES: "/User/get-all-dipute-bulk-logs",
    DOWNLOAD_UPLOADED_FILE: (id) => `/User/download-uploaded/${id}`,
    DOWNLOAD_FILE: (id) => `/User/download-log/${id}`,
  },

  // Chat
  CHAT: {
    START: "/Chat/start",
    MESSAGES: (chatId, userId, role) => `/Chat/${chatId}/messages/${userId}/${role}`,
  },

  // Email & Promotion
  CAN_SEND_MAIL: "/CanSendMail",
  PROMOTION: {
    FETCH: "/Customer/get-all-promotion-file",
    SEND_EMAIL: "/Customer/send-email-promotion",
    DOWNLOAD_FILE: (id) => `/Customer/download-promotion-file/${id}`,
  },

  // Profile Image
  PROFILE_IMAGE: {
    UPLOAD: (username) => `/User/profile-image/${username}`,
    GET: (username) => `/User/profile-image/${username}`,
    DELETE: (username) => `/User/profile-image/${username}`,
  },

  // Privileges & Permissions
  PRIVILEGE_TYPES: "/Permissions/permissions",
  USER_PERMISSIONS: (id) => `/Permissions/userpermissions/${id}`,
  ASSIGN_USER_PRIVILEGE: "/Permissions/userpermissions",
  ROLE_PERMISSIONS: (id) => `/Permissions/rolepermissions/${id}`,
  ASSIGN_ROLE_PRIVILEGE: "/Permissions/rolepermissions",

  // Health
  HEALTH: "/Health",
};

export default ENDPOINTS;
